import clsx from "clsx";
import React, { FC, ForwardedRef, InputHTMLAttributes } from "react";
import styled from "styled-components";

import { FormErrorModel } from "@ryde/shared";
import { deepPurpleMui, greyMui, redMui, rydeColors } from "@ryde/theme";

interface ITextArea extends InputHTMLAttributes<HTMLTextAreaElement> {
  isValid?: boolean;
  rows?: number;
  cols?: number;
  error?: FormErrorModel;
}

const TextAreaStyled = styled.textarea<ITextArea>`
  color: ${props => props.color || rydeColors.greyFocusedInput};
  rows: ${props => props.rows};
  cols: ${props => props.cols};
  font-family: inherit;
  resize: vertical;
  display: block;
  width: ${props => props.width || "100%"};
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-color: ${rydeColors.white};
  background-clip: padding-box;
  border: 1px solid ${greyMui._300};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.375rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:focus {
    background-color: ${rydeColors.white};
    border-color: ${rydeColors.lightBlue};
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
  }
  &:hover:not([disabled]) {
    border-color: ${deepPurpleMui._300};
  }
  &:disabled {
    background: ${greyMui._300};
  }
  &::placeholder {
    color: ${rydeColors.grey};
  }
  &.error {
    border-color: ${redMui._600};
  }
`;

const InputErrorStyled = styled.div`
  color: ${redMui._600};
  margin-inline-start: 6px;
`;

export const TextArea: FC<ITextArea> = React.forwardRef(
  (props, ref: ForwardedRef<HTMLTextAreaElement>) => {
    return (
      <>
        <TextAreaStyled
          {...props}
          className={clsx({ error: props.error }, props.className)}
          ref={ref}
        />
        {!!props.error && (
          <InputErrorStyled>{props.error as string}</InputErrorStyled>
        )}
      </>
    );
  },
);
